<button mat-button (click)="changeLanguage(currentLang)">
  {{otherLang | translate}}
</button>